import Header from "components/Header/Header.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    city: state.city,
    attributes: state.attributes,
    user: state.user
  };
}

const HeaderContainer = connectFunction(mapStateToProps)(Header);
export default HeaderContainer;
